import { Table, flexRender } from '@tanstack/react-table';
import { TableCell, TableFooter, TableRow } from '@sib/ui';

interface SibTableFooterProps<T> {
  table: Table<T>;
}

export const SibTableFooter = <T,>({ table }: SibTableFooterProps<T>) => (
  <TableFooter>
    {table.getFooterGroups().map(footerGroup => (
      <TableRow key={footerGroup.id}>
        {footerGroup.headers.map(header => (
          <TableCell key={header.id}>
            {flexRender(header.column.columnDef.footer, header.getContext())}
          </TableCell>
        ))}
      </TableRow>
    ))}
  </TableFooter>
);
